/**
 * Loans Report Page
 */
import React from 'react';

const LoansReport = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Loans Report</h1>
      <p className="text-gray-600 dark:text-gray-400 mt-2">Detailed loans report</p>
    </div>
  );
};

export default LoansReport;
